// VER-218: request a password reset. Always shows the same confirmation
// (anti-enumeration) — the backend never reveals whether the email exists.
import { useState } from "react";
import { Link } from "react-router-dom";
import { App, Button, Card, Form, Input, Typography, Result } from "antd";
import { authApi } from "../console/consoleApi";

const { Title, Text } = Typography;

export default function ForgotPassword() {
  const { message } = App.useApp();
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async ({ email }) => {
    setLoading(true);
    try {
      await authApi.forgotPassword(email.trim());
      setSent(true); // backend always 200 — show the same message regardless
    } catch {
      message.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 24 }}>
      <Card style={{ width: 400 }}>
        {sent ? (
          <Result
            status="success"
            title="Check your email"
            subTitle="If an account exists for that email, we've sent a password reset link. It expires in 1 hour."
            extra={
              <Link to="/console/login">
                <Button type="primary">Back to sign in</Button>
              </Link>
            }
          />
        ) : (
          <>
            <Title level={3} style={{ marginBottom: 4 }}>
              Reset your password
            </Title>
            <Text type="secondary">Enter your email and we'll send you a reset link.</Text>
            <Form
              layout="vertical"
              onFinish={handleSubmit}
              style={{ marginTop: 16 }}
              disabled={loading}
              requiredMark={false}
            >
              <Form.Item
                name="email"
                label="Email"
                rules={[{ required: true, type: "email", message: "Enter a valid email" }]}
              >
                <Input placeholder="you@company.com" size="large" autoComplete="username" />
              </Form.Item>
              <Button type="primary" htmlType="submit" block size="large" loading={loading}>
                Send reset link
              </Button>
              <div style={{ marginTop: 12, textAlign: "center" }}>
                <Link to="/console/login">Back to sign in</Link>
              </div>
            </Form>
          </>
        )}
      </Card>
    </div>
  );
}
